<template>
  <div class="home">
  
    <Reproductor msg="Los Animales domésticos" audio2="../mp3/PrimariaD/02PD.mp3" cover="../img/4.jpg" name="Primaria D - Lección #2"/>
    <Buttons/>
  </div>
</template>

<script>
// @ is an alias to /src

import Buttons from '@/components/Buttons.vue'
import Reproductor from '@/components/Reproductor.vue'
export default {
  name: 'LeccionA1',

  components: {
    Reproductor,
    Buttons,
    
  }
}
</script>
